import { AppRoutes } from '@constants/app-routes'

const currentYear = new Date().getFullYear()

export const config = {
  links: [
    {
      id: 1,
      label: 'Go to Linkedin',
      path: 'https://www.linkedin.com/company/modsen',
      imagePath: '/images/linkedin-footer.svg',
      imageWidth: '24',
      imageHeight: '24',
    },
    {
      id: 2,
      label: 'Go to Instagram',
      path: 'https://www.instagram.com/modsencompany',
      imagePath: '/images/instagram-footer.svg',
      imageWidth: '24',
      imageHeight: '24',
    },
    {
      id: 3,
      label: 'Go to Facebook',
      path: 'https://www.facebook.com/ModsenSoftware',
      imagePath: '/images/facebook-footer.svg',
      imageWidth: '12',
      imageHeight: '24',
    },
    {
      id: 4,
      label: 'Go to X',
      path: 'https://twitter.com/modsencompany',
      imagePath: '/images/ri_twitter-x-fill.svg',
      imageWidth: '24',
      imageHeight: '24',
    },
    {
      id: 5,
      label: 'Go to Dribbble',
      path: 'https://dribbble.com/ModsenDesign',
      imagePath: '/images/icon-park-outline_dribble.svg',
      imageWidth: '24',
      imageHeight: '24',
    },
    {
      id: 6,
      label: 'Go to Youtube',
      path: 'https://www.youtube.com/@modsencompany',
      imagePath: '/images/youtube.svg',
      imageWidth: '24',
      imageHeight: '24',
    },
  ],
  mailLink: {
    id: 3,
    label: 'contact@modsen-software.com',
    path: 'mailto:contact@modsen-software.com',
  },
  phoneLink: {
    id: 'phone',
    label: '+48501157180',
    path: 'tel:+48501157180',
  },
  groups: [
    {
      title: 'Services',
      links: [
        {
          label: 'Scale your team',
          path: AppRoutes.scaleYourTeam,
        },
        {
          label: 'Develop your product',
          path: AppRoutes.developYourProduct,
        },
        {
          label: 'Design Studio',
          path: AppRoutes.designStudio,
        },
        {
          label: 'Quality Assurance',
          path: AppRoutes.qualityAssurance,
        },
        {
          label: 'Business analysis',
          path: AppRoutes.businessAnalysisServices,
        },
      ],
    },
    {
      title: 'Technologies',
      links: [
        {
          label: 'Front-end',
          path: AppRoutes.frontend,
        },
        {
          label: 'Back-end',
          path: AppRoutes.backend,
        },
        {
          label: 'DevOps',
          path: AppRoutes.devOps,
        },
        {
          label: 'Mobile Development',
          path: AppRoutes.mobileDevelopment,
        },
      ],
    },
    {
      title: 'Approach',
      links: [
        {
          label: 'Agile',
          path: AppRoutes.agileProjectManagement,
        },
        {
          label: 'Sustainability',
          path: AppRoutes.sustainableSoftwareDevelopment,
        },
      ],
    },
    {
      title: 'Industries',
      links: [
        {
          label: 'Fintech',
          path: AppRoutes.fintech,
        },
        {
          label: 'Medtech',
          path: AppRoutes.medtech,
        },
        {
          label: 'IoT',
          path: AppRoutes.iot,
        },
        {
          label: 'Travel',
          path: AppRoutes.travel,
        },
        {
          label: 'Logistics',
          path: AppRoutes.logistics,
        },
        {
          label: 'Enterprises',
          path: AppRoutes.enterprise,
        },
        {
          label: 'Social Networking',
          path: AppRoutes.socialNetworking,
        },
        {
          label: 'AdTech',
          path: AppRoutes.adTech,
        },
        {
          label: 'Agriculture',
          path: AppRoutes.agriculture,
        },
        {
          label: 'EdTech',
          path: AppRoutes.edTech,
        },
      ],
    },
    {
      title: 'Company',
      links: [
        {
          label: 'Approach',
          path: AppRoutes.approach,
        },
        {
          label: 'About us',
          path: AppRoutes.aboutUs,
        },
        {
          label: 'Partnership',
          path: AppRoutes.partnership,
        },
        {
          label: 'Career',
          path: AppRoutes.career,
        },
        {
          label: 'News',
          path: AppRoutes.news,
        },
        {
          label: 'Blog',
          path: AppRoutes.blog,
        },
        {
          label: 'Portfolio',
          path: AppRoutes.portfolio,
        },
        {
          label: 'Certification\nby Modsen',
          path: AppRoutes.certifications,
        },
      ],
    },
  ],
  copyrightText: `© Copyright ${currentYear} Modsen. All rights reserved.`,
  privacyText: 'Privacy policy',
  microsoftLogo: {
    src: '/images/microsoft-footer.webp',
    alt: 'microsoft',
    width: 151,
    height: 100,
  },
}
